import { FilteredOptionsIds } from "../../../common/pricing/add-item-modal/components/MatrixSelection"
import { TYPE_MATRICES } from "../Constants"
import { MATRIX_AXIS_TYPE } from "../Types"
import { VariantsIds } from "../pricingbrackets/PricingBrackets"
import { MatrixAxisOptionDto } from "./matrix-axis-option/MatrixAxisOption"
import { MatrixItemDto } from "./matrix-item/MatrixItem"

export type MatrixAxis = {
    name: string
    type: MATRIX_AXIS_TYPE
    options: MatrixAxisOptionDto[]
}

export type MatrixDtoAttributes = {
    didUpdate_: boolean
    accountId: string
    createdAt: string
    createdByUserId: string
    deletedAt: string
    deletedByUserId: string
    items: MatrixItemDto[]
    parentProductId: string
    updatedAt: string
    updatedByUserId: string
    axes: MatrixAxis[]
    xAxis: MatrixAxis
    yAxis: MatrixAxis
    zAxis: MatrixAxis
}

export type MatrixDto = {
    id: string
    type: string
    attributes: MatrixDtoAttributes
}

export const initialMatrixAxisState: MatrixAxis = {
    name: "",
    type: MATRIX_AXIS_TYPE.X,
    options: []
}

export const initialMatrixStateAttributes: MatrixDtoAttributes = {
    didUpdate_: true,
    axes: [],
    accountId: "",
    createdAt: "",
    createdByUserId: "",
    deletedAt: "",
    deletedByUserId: "",
    items: [],
    parentProductId: "",
    updatedAt: "",
    updatedByUserId: "",
    xAxis: initialMatrixAxisState,
    yAxis: initialMatrixAxisState,
    zAxis: initialMatrixAxisState
}

export const initialMatrixState: MatrixDto = {
    id: "",
    type: "",
    attributes: initialMatrixStateAttributes,
}

export default class Matrix {
    private dto: MatrixDto

    constructor(dto: MatrixDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.type === TYPE_MATRICES
            && this.getId() != ""
    }

    getId(): string {
        return this.dto.id
    }

    getDto(): MatrixDto {
        return this.dto
    }

    getAttributes(): MatrixDtoAttributes {
        return this.dto.attributes
    }

    getAxes(includeNull = false): MatrixAxis[] {
        return this.getAttributes().axes.filter((axis) => includeNull || !!axis.options)
    }

    getMatrixItems(includeDeletedItems = false): MatrixItemDto[] {
        if (includeDeletedItems) {
            return this.getAttributes().items
        } else {
            return this.getAttributes().items.filter(i => !i.attributes.deleted)
        }
    }

    getFilteredMatrixItems(x: string | null, y: string | null, z: string | null): MatrixItemDto[] {
        return this.getMatrixItems().filter(item => {
            return (!x || item.attributes.xMatrixAxisOptionId == x)
                && (!y || item.attributes.yMatrixAxisOptionId == y)
                && (!z || item.attributes.zMatrixAxisOptionId == z)
        })
    }

    getFilteredMatrixItemsOptionsIds(x: string | null, y: string | null, z: string | null): FilteredOptionsIds {
        return {
            [MATRIX_AXIS_TYPE.X]: [...new Set(this.getFilteredMatrixItems(null, y, z).map(curr =>
                curr.attributes.xMatrixAxisOptionId))],
            [MATRIX_AXIS_TYPE.Y]: [...new Set(this.getFilteredMatrixItems(x, null, z).map(curr =>
                curr.attributes.yMatrixAxisOptionId))],
            [MATRIX_AXIS_TYPE.Z]: [...new Set(this.getFilteredMatrixItems(x, y, null).map(curr =>
                curr.attributes.zMatrixAxisOptionId))],
        }
    }

    findMatrixItem(x: string | null, y: string | null, z: string | null): MatrixItemDto | undefined {
        return this.getMatrixItems().find((item) => {
            return this.getAxes().every(axis => {
                switch(axis.type) {
                case MATRIX_AXIS_TYPE.X:
                    return item.attributes.xMatrixAxisOptionId === x
                case MATRIX_AXIS_TYPE.Y:
                    return item.attributes.yMatrixAxisOptionId === y
                case MATRIX_AXIS_TYPE.Z:
                    return item.attributes.zMatrixAxisOptionId === z
                default:
                    return false
                }
            })
        })
    }

    findMatrixItems(x: string | null, y: string | null, z: string | null): VariantsIds[] {
        return this.getMatrixItems().filter((item) => {
            const xAxisCond = (x && item.attributes.xMatrixAxisOptionId === x) || !x
            const yAxisCond= (y && item.attributes.yMatrixAxisOptionId === y) || !y
            const zAxisCond=(z && item.attributes.zMatrixAxisOptionId === z) || !z
            return xAxisCond && yAxisCond && zAxisCond    
        }).map(i => {
            return { variantId: i.attributes.productId, variantName: i.attributes.product.attributes.title } as VariantsIds
        })
    }
}







// WEBPACK FOOTER //
// ./src/state/product/matrix/Matrix.ts